import { User } from "../gateway/User/User";

export class RemoveUserByIdsUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ _ids = [] } = {}) {
        const payload = this.sanitizeInput({ _ids });
        if (!payload._ids.length) return null;
        const response = await this.UserGateway.removeByIds(payload._ids);
        return response;
    }

    sanitizeInput({ _ids = [] } = {}) {
        const sanitizedIds = Array.isArray(_ids)
            ? _ids
                  .map((id) => String(id).trim())
                  .filter((id) => Boolean(id))
            : [];
        return {
            _ids: sanitizedIds
        };
    }
}
